import EmblaCarousel from "embla-carousel";
import { initEmblaProgress } from "@theme/critical";

function initCarousel(carousels) {
  if (!carousels.length) return;

  carousels.forEach((carousel) => {
    if (Shopify.designMode == undefined) {
      const viewportNode = carousel.querySelector(".embla__viewport");
      const embla = EmblaCarousel(viewportNode, {
        loop: true,
        align: "center",
        draggable: false,
        dragFree: false,
        watchDrag: false,
      });

      const section = carousel.getAttribute("data-section");
      if (section) {
        const sectionNode = document.querySelector(`#${section}`);
        const next_buttons = sectionNode.querySelectorAll(".next");
        const prev_buttons = sectionNode.querySelectorAll(".prev");

        next_buttons.forEach((button) => {
          button.addEventListener("click", () => {
            embla.scrollNext();
          });
        });

        prev_buttons.forEach((button) => {
          button.addEventListener("click", () => {
            embla.scrollPrev();
          });
        });

        const banners = sectionNode.querySelectorAll(".shop-the-look-banner");
        if (banners.length) {
          const mobileMq = window.matchMedia("(max-width: 1024px)");

          banners.forEach((banner) => {
            let pointerId = null;
            let startX = 0;
            let startY = 0;
            let hasScrolled = false;

            const reset = () => {
              hasScrolled = false;
              pointerId = null;
            };

            const onPointerDown = (event) => {
              if (!mobileMq.matches || event.pointerType !== "touch") return;
              hasScrolled = false;
              pointerId = event.pointerId;
              startX = event.clientX;
              startY = event.clientY;
              banner.setPointerCapture(pointerId);
            };

            const onPointerMove = (event) => {
              if (pointerId !== event.pointerId || !mobileMq.matches || event.pointerType !== "touch") return;

              const deltaX = event.clientX - startX;
              const deltaY = event.clientY - startY;

              if (hasScrolled) return;

              // Serve un gesto principalmente orizzontale per scatenare lo scroll
              if (Math.abs(deltaX) < 12 || Math.abs(deltaX) < Math.abs(deltaY)) {
                return;
              }

              event.preventDefault();

              if (deltaX < 0) {
                embla.scrollNext();
              } else {
                embla.scrollPrev();
              }

              // Evita ripetizioni finché il tocco corrente termina
              hasScrolled = true;
            };

            const onPointerUpCancel = (event) => {
              if (pointerId === event.pointerId) {
                if (banner.hasPointerCapture(pointerId)) {
                  banner.releasePointerCapture(pointerId);
                }
                reset();
              }
            };

            banner.addEventListener("pointerdown", onPointerDown, {
              passive: true,
            });
            banner.addEventListener("pointermove", onPointerMove, {
              passive: false,
            });
            banner.addEventListener("pointerup", onPointerUpCancel, {
              passive: true,
            });
            banner.addEventListener("pointercancel", onPointerUpCancel, {
              passive: true,
            });
          });
        }
      }
    }

    carousel.querySelectorAll(".shop-the-look").forEach((look) => {
      const product_carousel = look.querySelector(
        ".shop-the-look-products .embla__viewport",
      );

      const slideCount =
        product_carousel.querySelectorAll(".embla__slide").length;
      const needsLoop = slideCount > 1;

      const product_embla = EmblaCarousel(product_carousel, {
        loop: needsLoop,
        align: "start",
        dragFree: false,
        dragThreshold: 10,
        skipSnaps: false,
        containScroll: slideCount <= 2 ? false : "trimSnaps", // ← chiave del fix
      });

      initEmblaProgress(product_carousel, product_embla);

      product_embla.on("select", () => {
        console.log("Selected:", product_embla.selectedScrollSnap());
      });

      const badges = look.querySelectorAll(".shop-the-look-badge");
      badges.forEach((badge) => {
        badge.addEventListener("click", () => {
          const targetIndex = parseInt(badge.dataset.target, 10);
          const snapCount = product_embla.scrollSnapList().length;
          if (targetIndex < snapCount) {
            product_embla.scrollTo(targetIndex);
          }
        });
      }); 
    });
  });
}

function initSections() {
  const carousels = document.querySelectorAll(".embla.lookbook");
  initCarousel(carousels);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initSections, { once: true });
} else {
  initSections();
}

document.addEventListener("shopify:section:load", function (event) {
  if (
    event.target instanceof HTMLElement &&
    event.target.classList.contains("shop-the-look-section")
  ) {
    const carousels = event.target.querySelectorAll(".embla.lookbook");
    initCarousel(carousels);
  }
});
